class ProductShippingCalculator extends ShippingCalculator {
  constructor() {
    super();
    this.addressCountrySelect = this.querySelector('select[id^="AddressCountryCalculator-"]');
    this.addressProvinceSelect = this.querySelector('select[id^="AddressProvinceCalculator-"]');
    this.addressZipInput = this.querySelector('input[id^="AddressZipCalculator-"]');
    this.addedLineKey = null;
    this.isSelfReverting = false;
  }

  getProductForm() {
    return document.getElementById(this.dataset.productFormId);
  }

  getSelectedVariantId() {
    const form = this.getProductForm();
    const input = form ? form.querySelector('input[name="id"]') : null;
    return input ? input.value : null;
  }

  getSelectedQuantity() {
    const form = this.getProductForm();
    const input = form ? form.querySelector('input[name="quantity"]') : null;
    const qty = input ? parseInt(input.value, 10) : 1;
    return isNaN(qty) || qty < 1 ? 1 : qty;
  }

  setupCountries() {
    // La clase base apunta a un ID de contenedor sin el sufijo -{{ section.id }},
    // que no existe en este snippet. Lo sobreescribimos con el ID real.
    const provinceContainer = this.querySelector('[id^="AddressProvinceContainerCalculator-"]');
    if (Shopify && Shopify.CountryProvinceSelector && provinceContainer) {
      new Shopify.CountryProvinceSelector(this.addressCountrySelect.id, this.addressProvinceSelect.id, {
        hideElement: provinceContainer.id
      });
    }
  }

  onButtonClick(event) {
    if (this.button.classList.contains('loading')) return;

    // Los reintentos internos de asyncShippingRates() vuelven a "clickear"
    // este botón; si ya agregamos el producto, dejamos que la clase base
    // maneje el resto sin volver a tocar el carrito.
    if (this.addedLineKey) {
      super.onButtonClick(event);
      return;
    }

    // OJO: no usamos this.startLoading() aquí — esa función pone la clase
    // 'loading', y el onButtonClick original de la clase base corta su
    // propia ejecución si esa clase ya está puesta. Solo deshabilitamos
    // el botón mientras agregamos el producto al carrito.
    this.button.setAttribute('aria-disabled', true);

    const variantId = this.getSelectedVariantId();
    if (!variantId) {
      this.button.setAttribute('aria-disabled', false);
      this.handleErrorResponse(['No se pudo identificar el producto seleccionado.']);
      return;
    }

    fetch(`${routes.cart_add_url}.js`, {
      ...fetchConfig('json', 'POST'),
      body: JSON.stringify({ id: variantId, quantity: this.getSelectedQuantity() })
    })
      .then((response) => response.json())
      .then((addedItem) => {
        this.addedLineKey = addedItem.key;
        this.button.setAttribute('aria-disabled', false);
        super.onButtonClick(event);
      })
      .catch((e) => {
        this.button.setAttribute('aria-disabled', false);
        this.handleErrorResponse([e.message]);
      });
  }

  handleSuccessResponse(list) {
    super.handleSuccessResponse(list);
    this.revertCartLine();
  }

  handleErrorResponse(errors) {
    super.handleErrorResponse(errors);
    this.revertCartLine();
  }

  onCartChange() {
    // Nuestro propio revertCartLine() dispara 'afterCartChanged' para
    // refrescar el ícono del carrito; eso no debe ocultar el resultado
    // que esta misma calculadora acaba de mostrar.
    if (this.isSelfReverting) {
      this.isSelfReverting = false;
      return;
    }
    super.onCartChange();
  }

  revertCartLine() {
    if (!this.addedLineKey) return;
    const key = this.addedLineKey;
    this.addedLineKey = null;
    this.isSelfReverting = true;
    fetch(`${routes.cart_change_url}.js`, {
      ...fetchConfig('json', 'POST'),
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(() => document.dispatchEvent(new CustomEvent('afterCartChanged')))
      .catch(() => { this.isSelfReverting = false; });
  }
}

if (!customElements.get('product-shipping-calculator')) {
  customElements.define('product-shipping-calculator', ProductShippingCalculator);
}